import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import BusinessCard from './components/BusinessCard.jsx';

ReactDOM.render(
  <React.StrictMode>
    <BusinessCard />
  </React.StrictMode>,
  document.getElementById('root')
);
